// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-preview-container {
    background: #fefdf8;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
    font-family: 'Segoe UI', sans-serif;
    animation: fadeIn 0.4s ease;
  }
  
  .slide-content-box {
    background: #ffffff;
    border: 2px solid #dcca98;
    border-radius: 10px;
    padding: 20px;
    position: relative;
  }
  
  .slide-header {
    position: absolute;
    top: 10px;
    right: 16px;
    font-size: 0.8rem;
    color: #888;
  }
  
  .slide-title {
    font-size: 1.1rem;
    font-weight: bold;
    color: #114040;
    margin-bottom: 12px;
  }
  
  .slide-text {
    font-size: 0.95rem;
    color: #333;
    line-height: 1.5;
    margin: 0;
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  `, "",{"version":3,"sources":["webpack://./src/home/Tools/SlidePreview.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,0CAA0C;IAC1C,mCAAmC;IACnC,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC/C","sourcesContent":[".slide-preview-container {\n    background: #fefdf8;\n    padding: 16px;\n    border-radius: 12px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);\n    font-family: 'Segoe UI', sans-serif;\n    animation: fadeIn 0.4s ease;\n  }\n  \n  .slide-content-box {\n    background: #ffffff;\n    border: 2px solid #dcca98;\n    border-radius: 10px;\n    padding: 20px;\n    position: relative;\n  }\n  \n  .slide-header {\n    position: absolute;\n    top: 10px;\n    right: 16px;\n    font-size: 0.8rem;\n    color: #888;\n  }\n  \n  .slide-title {\n    font-size: 1.1rem;\n    font-weight: bold;\n    color: #114040;\n    margin-bottom: 12px;\n  }\n  \n  .slide-text {\n    font-size: 0.95rem;\n    color: #333;\n    line-height: 1.5;\n    margin: 0;\n  }\n  \n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to   { opacity: 1; transform: translateY(0); }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
